import type { InfoWithIconProps } from "./info-with-icon.type";

import { Tooltip, Typography } from "antd";

import "./info-with-icon.style.less";

const { Text } = Typography;

export const InfoWithIcon = ({ text, tooltip, icon }: InfoWithIconProps) => (
  <Tooltip title={tooltip}>
    <Text ellipsis className="info-with-icon">
      {icon} {text}
    </Text>
  </Tooltip>
);
